import createReducer from '../../utils/createReducer';
import actions from './actions';

const actionHandlers = {};
export const initialState = {
    error: null,
    isModalOpen: false,
    inviteUrl: '',
    loginUrl: '',
    signupUrl: '',
    loading: false
};

actionHandlers[actions.COLLABORATE] = (state) => {
    const isModalOpen = !state.isModalOpen;
    return {
        ...state,
        isModalOpen
    };
};

actionHandlers[actions.FETCH_INVITE] = (state) => {
    return {
        ...state,
        loading: true
    };
};

actionHandlers[actions.FETCH_INVITE_ERROR] = (state) => {
    /** @todo Pass through error codes... */
    return {
        ...state,
        error: true,
        loading: false
    };
};

actionHandlers[actions.FETCH_INVITE_SUCCESS] = (state, {payload}) => {
    let {apiData} = payload;
    return {
        ...state,
        ...apiData,
        loading: false
    };
};

actionHandlers[actions.FETCH_LOGIN] = (state) => {
    return {
        ...state,
        loading: true
    };
};

actionHandlers[actions.FETCH_LOGIN_ERROR] = (state) => {
    /** @todo Pass through error codes... */
    return {
        ...state,
        error: true,
        loading: false
    };
};

actionHandlers[actions.FETCH_LOGIN_SUCCESS] = (state, {payload}) => {
    let {apiData} = payload;
    const loginUrl = apiData.header.login.items[0].link;
    return {
        ...state,
        loginUrl,
        loading: false
    };
};

actionHandlers[actions.RESET] = () => initialState;

export default createReducer(actionHandlers, initialState);


// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/reducer-collaborate.js